import { Component } from '@angular/core'
import { ActivatedRoute, RouterOutlet } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { ButtonModule } from 'primeng/button'
import { HeaderComponent } from './components/header/header.component'
import { ThemeService } from './services/theme/theme.service'
import { PrimeNG } from 'primeng/config'
import { Toast } from 'primeng/toast'
import { AuthService } from './services/auth.service'

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ButtonModule, HeaderComponent, Toast],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'GALEC Front'

  constructor(
    private translateService: TranslateService,
    private themeService: ThemeService,
    private config: PrimeNG,

  ) {
    this.translateService.setDefaultLang('fr')
    this.translateService.use('fr')
    this.translateService
      .get('primeng')
      .subscribe((res) => this.config.setTranslation(res))
  }
}
